import React from 'react'

export type Props = {
  setRedeeming: (nextValue: boolean) => void
  redeemLoading: boolean
}

export const defaultContext: Props = {
  setRedeeming: () => null,
  redeemLoading: false,
}

const UrlPromoCodeContext = React.createContext<Props>(defaultContext)

export default UrlPromoCodeContext
